export default __webpack_public_path__ + "static/media/cake.3d01c832.svg";